export enum BrandPrefixEnum {
    Pml = 'pml',
    Pvl = 'pvl',
  }
  